export default "__VITE_ASSET__WgKE1G2C__"